import { Pipe, PipeTransform } from "@angular/core";
import { EventBasic } from "../models/events/event-basic.model";

@Pipe({
    name: 'EventDates'
})
export class EventDatesPipe implements PipeTransform {
    transform(value?: EventBasic, ...args: any[]): Date[] {
        const eventDates: Date[] = []
        if (value){
            if (new Date(value.eventStart).getDate() === new Date(value.eventEnd).getDate()){
                eventDates.push(value.eventStart);
            }
            else {
                for (var d = new Date(value.eventStart); d <= new Date(value.eventEnd); d.setDate(d.getDate() + 1)) {
                    eventDates.push(d)
                }
            }
        }
        return eventDates;
    }
}